const paths = {
  backlog: '/jobs/backlog',
  import: '/jobs/import',
  board: '/jobs/board',
  report: '/jobs/report',
  workingActivityReport: '/jobs/workingActivityReport'
};

export default paths;
